import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { trigger, animate, transition, style, keyframes } from '@angular/animations';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { BaseComponent } from '../base.component';
import { EditPopup } from '../edit-popup';
import { SharedService } from '../shared.service';
import { WoService } from 'app/layout/work-order/work-order.service';
import { LoaderService } from '../loader.service';
import { JobStatusPopupEntity, JobStatusLatLanEntity, JobStatusPopupInputSearchEntity, ResponseJobStatusPopupList, Direction, Severities } from '../shared.model';
import { CapitalizeFirstPipe } from '../pipes/custom-pipes.pipe';


declare var google: any;
declare var Microsoft: any;
declare var window: any;

@Component({
  selector: 'app-live-tracking',
  templateUrl: 'work-order-statuspopup.html',
  providers: [WoService],
  animations: [
    trigger('isVisibleChanged', [
      transition('void => *', [
        animate(600, keyframes([
          style({ opacity: 0, transform: 'translateY(-200px)', offset: 0 }),
          style({ opacity: 1, transform: 'translateY(25px)', offset: .75 }),
          style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
        ]))
      ])
    ])
  ],
  styles: [`
    #map_canvas {
        width: 350px;
        height: 300px;
      }`]
})
export class JobstatuspopupComponent extends BaseComponent implements OnInit, EditPopup {
  @Output() done = new EventEmitter();
  @Input() WoJobId: string;
  @ViewChild('map_canvas', { read: ElementRef }) mapElement: ElementRef;
  map;
  marker;
  startPos = [42.42679066670903, -83.29210638999939];
  speed = 50; // km/h
  delay = 100;

  hour: string;
  minutes: number;
  hour1: string;
  minutes1: number;
  jobstatus: string = "Web";
  jobduration: string;
  woaddress: string = "N/A";
  contactDetails: string;
  isHideMap: boolean = false;
  jobStatusPopupEntity = new JobStatusPopupEntity;
  jobStatusLatLanEntity = new JobStatusLatLanEntity;
  Description: string;
  markers = [];
  jobStatusPopupInputSearchEntity = new JobStatusPopupInputSearchEntity;
  private responseJobStatusPopupList: ResponseJobStatusPopupList = new ResponseJobStatusPopupList;
  TechStartPoint: any;
  TechEndtPoint: any;
  comparelenght: number;
  direction: Direction = new Direction();
  CompareJGotoLatLanEntity: JobStatusLatLanEntity[] = [];
  currentAnimation: any;
  _delay: any = 30;    //Time in ms between each frame of the animation
  EARTH_RADIUS_KM = 6378.1;
  PathAnimation: any;
  BaseAnimation: any; _timerId: any;
  frameIdx: any = 0;
  _isPaused: any = false;
  play: any;
  bing: any;
  fullScreenIcon: boolean = false;
  isVisible: any;
  MapRefreshTime: number = 20000;
  pageloadtimer: any;
  autoRefreshTimer: number = 5000;
  // google map --
  scriptStartFirstIcon;
  scriptStartNextIcon;
  scriptEndIcon;
  shape;
  scriptStartMarker;
  scriptEndMarker;
  currentMapTrack = null;
  // -- google map
  constructor(protected sharedService: SharedService, protected woService: WoService,
    private loaderService: LoaderService, private router: Router,
    protected translate: TranslateService, private datePipe: DatePipe,
    public zone: NgZone) {
    super(sharedService, translate);
  }

  ngOnInit() {


    this.woService.getMapSettings().subscribe(
      s => {
        this.MapRefreshTime = s.REFRESHTIME;
        this.autoRefreshTimer = s.AUTOREFRESHTIME; // 15000 - 15 sec
      }
    );

    this.pageloadtimer = setInterval(() => { this.autoRefresh(); }, this.autoRefreshTimer);
    this.jobStatusPopupInputSearchEntity.CompanyId = super.globalInfo().CompanyId;
    this.jobStatusPopupInputSearchEntity.WoJobId = this.WoJobId;
    this.jobStatusPopupInputSearchEntity.TrackId = null;
    this.loaderService.show();
    this.woService.getJobStatusPopupList(this.jobStatusPopupInputSearchEntity, null, null, 0, 10)
      .subscribe(res => this.FilJobStatusListDetails(res));
  }

  //Allocate ModelPopup open Close
  FilJobStatusListDetails(res: ResponseJobStatusPopupList) {
    this.loaderService.hide();
    if (!this.jobStatusPopupInputSearchEntity)
      this.jobStatusPopupEntity = new JobStatusPopupEntity;
    if (!this.jobStatusLatLanEntity)
      this.jobStatusLatLanEntity = new JobStatusLatLanEntity;


    this.responseJobStatusPopupList.jobStatuPopuplatlanList = res.jobStatuPopuplatlanList;
    this.responseJobStatusPopupList.jobStatuPopupEntityList = res.jobStatuPopupEntityList;


    if (this.responseJobStatusPopupList.jobStatuPopupEntityList.length > 0) {
      let data = this.responseJobStatusPopupList.jobStatuPopupEntityList[0];
      this.jobStatusPopupEntity.CustomerLong = data.CustomerLong;
      this.jobStatusPopupEntity.CustomerLat = data.CustomerLat;
      this.jobStatusPopupEntity.DisplayName = data.DisplayName;
      this.jobStatusPopupEntity.Phone1 = data.Phone1;
      this.jobStatusPopupEntity.PhotoPath = data.PhotoPath;
      this.jobStatusPopupEntity.ScheduleStartDateCtz = data.ScheduleStartDateCtz;
      this.jobStatusPopupEntity.WoCategory = data.WoCategory;
      this.jobStatusPopupEntity.WoJobId = data.WoJobId;
      this.jobStatusPopupEntity.WoNumber = data.WoNumber;
      this.jobStatusPopupEntity.WorkStartsLat = data.WorkStartsLat;
      this.jobStatusPopupEntity.WorkStartsLong = data.WorkStartsLong;
      this.jobStatusPopupEntity.WorkTask = data.WorkTask;
      this.jobStatusPopupEntity.WorkType = data.WorkType;
      this.jobStatusPopupEntity.ScheduleTime = data.ScheduleTime;
      this.jobStatusPopupEntity.OnSiteDate = data.OnSiteDate;
      this.jobStatusPopupEntity.OnSiteTime = data.OnSiteTime;
      this.jobStatusPopupEntity.EnRouteDate = data.EnRouteDate;
      this.jobStatusPopupEntity.EnRouteTime = data.EnRouteTime;
      this.Description = this.jobStatusPopupEntity.WoCategory + "  " + this.jobStatusPopupEntity.WorkType + "  " + this.jobStatusPopupEntity.WorkTask;
      this.jobStatusPopupEntity.CompletedDate = data.CompletedDate;
      this.jobStatusPopupEntity.CompletedTime = data.CompletedTime;
      this.jobStatusPopupEntity.JobStatus = data.JobStatus;
    }

    let WorkStartsLat = +this.jobStatusPopupEntity.WorkStartsLat;
    let WorkStartsLong = +this.jobStatusPopupEntity.WorkStartsLong;
    let CustomerLat = +this.jobStatusPopupEntity.CustomerLat;
    let CustomerLong = +this.jobStatusPopupEntity.CustomerLong;

    // If have Tracking Routes
    if (this.responseJobStatusPopupList.jobStatuPopuplatlanList.length > 0) {
      if (this.globalInfo().MapId == '1')
        this.bingMap();
      else {
        this.googleObject();
        this.googleMap(WorkStartsLat, WorkStartsLong, CustomerLat, CustomerLong);
      }
    }
    // Customer & technician Points
    else {
      if (this.globalInfo().MapId == '1')
        this.bingMap();
      else {
        this.googleObject();
        this.googleMap(WorkStartsLat, WorkStartsLong, CustomerLat, CustomerLong);
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.globalInfo().MapId == '1') {
      this.sharedService.loadDynamicScript()
        .load('animatedmaps', 'animationmodule')
        .then(() => {
        }).catch(error => console.log(error));
    }
  }

  ngOnDestroy() {
    if (this.pageloadtimer) {
      clearInterval(this.pageloadtimer);
    }
  }

  Refresh() {
    this.jobStatusPopupInputSearchEntity.CompanyId = super.globalInfo().CompanyId;
    this.jobStatusPopupInputSearchEntity.WoJobId = this.WoJobId;
    this.jobStatusPopupInputSearchEntity.TrackId = null;
    this.loaderService.show();
    this.woService.getJobStatusPopupList(this.jobStatusPopupInputSearchEntity, null, null, 0, 10)
      .subscribe(res => this.RefreshFilJobStatusListDetails(res));
  }

  RefreshFilJobStatusListDetails(res: ResponseJobStatusPopupList) {
    this.loaderService.hide();
    if (!this.jobStatusPopupEntity)
      this.jobStatusPopupEntity = new JobStatusPopupEntity;
    if (!this.jobStatusLatLanEntity)
      this.jobStatusLatLanEntity = new JobStatusLatLanEntity;

    this.responseJobStatusPopupList.jobStatuPopuplatlanList = res.jobStatuPopuplatlanList;
    this.responseJobStatusPopupList.jobStatuPopupEntityList = res.jobStatuPopupEntityList;
    let data = this.responseJobStatusPopupList.jobStatuPopupEntityList;
    if (data.length > 0) {
      let obj = data[0];
      this.jobStatusPopupEntity.CustomerLong = obj.CustomerLong;
      this.jobStatusPopupEntity.CustomerLat = obj.CustomerLat;
      this.jobStatusPopupEntity.DisplayName = obj.DisplayName;
      this.jobStatusPopupEntity.Phone1 = obj.Phone1;
      this.jobStatusPopupEntity.PhotoPath = obj.PhotoPath;
      this.jobStatusPopupEntity.ScheduleStartDateCtz = obj.ScheduleStartDateCtz;
      this.jobStatusPopupEntity.WoCategory = obj.WoCategory;
      this.jobStatusPopupEntity.WoJobId = obj.WoJobId;
      this.jobStatusPopupEntity.WoNumber = obj.WoNumber;
      this.jobStatusPopupEntity.WorkStartsLat = obj.WorkStartsLat;
      this.jobStatusPopupEntity.WorkStartsLong = obj.WorkStartsLong;
      this.jobStatusPopupEntity.WorkTask = obj.WorkTask;
      this.jobStatusPopupEntity.WorkType = obj.WorkType;
      this.jobStatusPopupEntity.ScheduleTime = obj.ScheduleTime;
      this.jobStatusPopupEntity.OnSiteDate = obj.OnSiteDate;
      this.jobStatusPopupEntity.OnSiteTime = obj.OnSiteTime;
      this.jobStatusPopupEntity.EnRouteDate = obj.EnRouteDate;
      this.jobStatusPopupEntity.EnRouteTime = obj.EnRouteTime;
      this.jobStatusPopupEntity.CompletedDate = obj.CompletedDate;
      this.jobStatusPopupEntity.CompletedTime = obj.CompletedTime;
      this.Description = this.jobStatusPopupEntity.WoCategory + "  " + this.jobStatusPopupEntity.WorkType + "  " + this.jobStatusPopupEntity.WorkTask;
      this.jobStatusPopupEntity.JobStatus = obj.JobStatus;
    }

    let compare = this.responseJobStatusPopupList.jobStatuPopuplatlanList;
    if (compare.length > 0) {
      this.TechStartPoint = this.responseJobStatusPopupList.jobStatuPopuplatlanList[compare.length - 1].lat;
      this.TechEndtPoint = this.responseJobStatusPopupList.jobStatuPopuplatlanList[compare.length - 1].lng;
    }
    if (this.responseJobStatusPopupList.jobStatuPopuplatlanList.length > 0)
      this.RefreshAndLoading();
  }

  RefreshAndLoading() {
    if (this.globalInfo().MapId == '1')
      this.refreshBingMap();
    else
      this.refreshGoogleMap();
  }

  autoRefreshMap(res: ResponseJobStatusPopupList) {
    if (this.globalInfo().MapId == '1') {
      this.autoRefreshBingMap(res);
    }
    else
      this.autoRefreshGoogleMap(res);
  }

  //#region  Google Map Start --
  googleMap(WorkStartsLat, WorkStartsLong, CustomerLat, CustomerLong, isAutoRefresh: boolean = false) {
    debugger;
    let directionsService = new google.maps.DirectionsService;
    let directionsRenderer = new google.maps.DirectionsRenderer;

    directionsService.route({
      origin: { lat: WorkStartsLat, lng: WorkStartsLong },
      destination: { lat: CustomerLat, lng: CustomerLong },
      travelMode: google.maps.TravelMode['DRIVING']
    }, (res, status) => {
      if (status == google.maps.DirectionsStatus.OK) {
        directionsRenderer.setDirections(res);
        var latlngs = JSON.stringify(res.routes[0].overview_path)
        var paths = JSON.parse(latlngs);
        let source = new google.maps.LatLng(WorkStartsLat, WorkStartsLong);
        let desination = new google.maps.LatLng(CustomerLat, CustomerLong);

        this.loadTarckScriptMap(paths, directionsRenderer, source, desination, isAutoRefresh)
      } else {
        console.warn(status);
        this.defaultScriptMap()
      }
    });
  }
  googleObject() {
    // google map --
    this.scriptStartFirstIcon = {
      url: '../assets/img/live-map/A.png',
      scaledSize: new google.maps.Size(30, 30),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(16, 16)
    };
    this.scriptStartNextIcon = {
      url: '../assets/img/live-map/car.png',
      scaledSize: new google.maps.Size(24, 24),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(16, 16)
    };
    this.scriptEndIcon = {
      url: '../assets/img/live-map/B.png',
      scaledSize: new google.maps.Size(30, 30),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(16, 16)
    };
    this.shape = {
      coords: [1, 1, 1, 20, 18, 20, 18, 1],
      type: "poly"
    };
    // --- google map
  }
  refreshGoogleMap() {
    let pathCoords = this.responseJobStatusPopupList.jobStatuPopuplatlanList;
    if (pathCoords.length > 0) {
      let mapOptions = {
        zoom: 13,
        center: { lat: pathCoords[0].lat, lng: pathCoords[0].lng },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: false
      }
      this.scriptMap = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
      this.GoogleautoRefresh(pathCoords);
    }
  }

  GoogleautoRefresh(pathCoords) {
    var i, route, marker;

    route = new google.maps.Polyline({
      path: [],
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2,
      editable: false,
      map: this.scriptMap
    });

    marker = new google.maps.Marker({ map: this.scriptMap, icon: this.scriptStartNextIcon });

    for (i = 0; i < pathCoords.length; i++) {
      setTimeout(function (coords) {
        var latlng = new google.maps.LatLng(coords.lat, coords.lng);
        route.getPath().push(latlng);
        this.moveMarker(this.scriptMap, marker, latlng);
      }, 200 * i, pathCoords[i]);
    }
  }

  moveMarker(map, marker, latlng) {
    marker.setPosition(latlng);
    map.panTo(latlng);
  }

  defaultScriptMap() {
    var latitude, longtitude;
    latitude = 11.446664;
    longtitude = 77.694336;
    let latLng = new google.maps.LatLng({ lat: latitude, lng: longtitude });
    let mapOptions = {
      zoom: 13,
      center: latLng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: false
    }
    this.scriptMap = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.startTrack = this.startTrack + 1;

  }

  startTrack: number = 0;
  scriptMap;
  startLatitude;
  startLongitude;
  loadTarckScriptMap(path, directionsRenderer, source, destination, isAutoRefresh: boolean) {
    this.startLatitude = path[0].lat;
    this.startLongitude = path[0].lng;
    if (isAutoRefresh) {
      if (this.startTrack == 0) {
        var middlePath = path[Math.round((path.length - 1) / 2)];
        let latLng = new google.maps.LatLng(middlePath);
        let mapOptions = {
          zoom: 15,
          center: latLng,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: false
        }
        this.scriptMap = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
        directionsRenderer.setMap(this.scriptMap);
        directionsRenderer.setOptions({ suppressMarkers: true });
        this.scriptStartMarker = new google.maps.Marker({
          map: this.scriptMap,
          animation: google.maps.Animation.DROP,
          icon: this.scriptStartFirstIcon,
          shape: this.shape,
          position: source,
        });
        // }

        this.scriptEndMarker = new google.maps.Marker({
          map: this.scriptMap,
          animation: google.maps.Animation.DROP,
          icon: this.scriptEndIcon,
          shape: this.shape,
          position: destination,
        });


        google.maps.event.addListenerOnce(this.scriptMap, 'idle', () => {
          if (isAutoRefresh)
            this.addScriptMarker(path)
        });
        google.maps.event.addListener(this.scriptMap, 'bounds_changed', () => {

        });
      } else {


        if (this.startLatitude != path[0].lat && this.startLongitude != path[0].lng) {
          var middlePath = path[Math.round((path.length - 1) / 2)];
          let latLng = new google.maps.LatLng(middlePath);
          let mapOptions = {
            zoom: 15,
            center: latLng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: false
          }
          this.scriptMap = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
          google.maps.event.addListenerOnce(this.scriptMap, 'idle', () => {

            this.scriptStartMarker = new google.maps.Marker({
              map: this.scriptMap,
              animation: google.maps.Animation.DROP,
              icon: this.scriptStartNextIcon,
              shape: this.shape,
              position: path[0],
            });


            this.scriptEndMarker = new google.maps.Marker({
              map: this.scriptMap,
              animation: google.maps.Animation.DROP,
              icon: this.scriptEndIcon,
              shape: this.shape,
              position: path[path.length - 1],
            });
            this.redrawPath(path)
          });
          google.maps.event.addListener(this.scriptMap, 'bounds_changed', () => {

          });
        } else {
          this.redrawPath(path)
        }
      }
    }
    else {

      let mapOptions = {
        zoom: 15,
        center: destination,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: false
      }
      this.scriptMap = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
      directionsRenderer.setMap(this.scriptMap);
      directionsRenderer.setOptions({ suppressMarkers: true });
      this.scriptStartMarker = new google.maps.Marker({
        map: this.scriptMap,
        animation: google.maps.Animation.DROP,
        icon: this.scriptStartFirstIcon,
        shape: this.shape,
        position: source,
      });
      // }

      this.scriptEndMarker = new google.maps.Marker({
        map: this.scriptMap,
        animation: google.maps.Animation.DROP,
        icon: this.scriptEndIcon,
        shape: this.shape,
        position: destination,
      });

    }
    this.fullScreenIcon = true;
  }

  addScriptMarker(path) {

    this.scriptStartMarker = new google.maps.Marker({
      map: this.scriptMap,
      animation: google.maps.Animation.DROP,
      icon: this.scriptStartNextIcon,
      shape: this.shape,
      position: path[0],
    });


    this.scriptEndMarker = new google.maps.Marker({
      map: this.scriptMap,
      animation: google.maps.Animation.DROP,
      icon: this.scriptEndIcon,
      shape: this.shape,
      position: path[path.length - 1],
    });

    this.redrawPath(path)
  }

  redrawPath(path) {
    if (this.currentMapTrack) {
      this.currentMapTrack.setMap(null);
    }

    if (path.length > 1) {
      this.currentMapTrack = new google.maps.Polyline({
        path: path,
        geodesic: true,
        strokeColor: '#00b49d',
        strokeOpacity: 5.0,
        strokeWeight: 10,
        icons: [
          {
            icon: this.scriptStartMarker,
            offset: "0%"
          },
          {
            icon: this.scriptEndMarker,
            offset: "100%"
          }
        ],
      });
      this.startLatitude = path[0].lat
      this.startLongitude = path[0].lng
      this.startTrack = this.startTrack + 1;
      this.currentMapTrack.setMap(this.scriptMap);
      var bounds = new google.maps.LatLngBounds();
      for (var i = 0; i < this.currentMapTrack.getPath().getLength(); i++) {
        bounds.extend(this.currentMapTrack.getPath().getAt(i));
      }
      this.scriptMap.fitBounds(bounds);

    }
  }


  autoRefreshGoogleMap(res) {
    let oldData = this.responseJobStatusPopupList.jobStatuPopuplatlanList;
    let previousLastpath = null;
    if (oldData.length > 0) {
      previousLastpath = oldData[(oldData.length - 1)];
      let a = this.responseJobStatusPopupList.jobStatuPopupEntityList;

      if (res.jobStatuPopuplatlanList && res.jobStatuPopuplatlanList.length > 0) {
        res.jobStatuPopuplatlanList.forEach(m => {
          this.googleMap(m.lat, m.lng, a[0].CustomerLat, a[0].CustomerLong, true);
        });
      }
    }
  }

  // Google Map End 
  //#endregion 

  //#region  Bing Map Start --

  bingMap() {

    this.sharedService.getMapKey(super.globalInfo().MapKey).subscribe(res => {
      if (res.Message.Severity == Severities.success) {
        let source = this.jobStatusPopupEntity.WorkStartsLat + ',' + this.jobStatusPopupEntity.WorkStartsLong;
        let destination = this.jobStatusPopupEntity.CustomerLat + ',' + this.jobStatusPopupEntity.CustomerLong;
    
        let WorkStartsLat = this.jobStatusPopupEntity.WorkStartsLat;
        let WorkStartsLong = this.jobStatusPopupEntity.WorkStartsLong;
        let CustomerLat = this.jobStatusPopupEntity.CustomerLat;
        let CustomerLong = this.jobStatusPopupEntity.CustomerLong;
    
    
        var directionsManager;
        var map = new Microsoft.Maps.Map(
          document.getElementById('map_canvas'),
          {
            credentials: res.Data,
            mapTypeId: Microsoft.Maps.MapTypeId.ROADMAP,
            center: new Microsoft.Maps.Location((this.jobStatusPopupEntity.CustomerLat), (this.jobStatusPopupEntity.CustomerLong)),
            zoom: 7
          });
    
        this.bing = map;
        this.fullScreenIcon = true;
    
        this.bing.entities.clear();
    
        if (source != destination) {
          Microsoft.Maps.loadModule('Microsoft.Maps.Directions', function () {
            directionsManager = new Microsoft.Maps.Directions.DirectionsManager(map);
            var SourceWaypoint = new Microsoft.Maps.Directions.Waypoint({ location: new Microsoft.Maps.Location(parseFloat(WorkStartsLat), parseFloat(WorkStartsLong)) });
            directionsManager.addWaypoint(SourceWaypoint);
            var DestinationWaypoint = new Microsoft.Maps.Directions.Waypoint({ location: new Microsoft.Maps.Location(parseFloat(CustomerLat), parseFloat(CustomerLong)) });
            directionsManager.addWaypoint(DestinationWaypoint);
            document.getElementById('mapdirection').innerHTML = "";
            directionsManager.setRenderOptions({ itineraryContainer: '#mapdirection' },
              { SourceWaypoint: { icon: '../assets/img/live-map/open.png' } });
            Microsoft.Maps.Events.addHandler(directionsManager, 'directionsError', function (args) {
              // notify.emit({ severity: 'error', detail: translate.instant('INVALIDLOCATION') });
              document.getElementById('mapdirection').innerHTML = "";
            });
            directionsManager.calculateDirections();
          });
    
        }
        // Same Location
        else {
          Microsoft.Maps.loadModule('Microsoft.Maps.Search', function () {
            var searchManager = new Microsoft.Maps.Search.SearchManager(map);
            var requestOptions = {
              bounds: map.getBounds(),
              where: source,
              callback: function (answer, userData) {
                map.setView({ bounds: answer.results[0].bestView });
                map.entities.push(new Microsoft.Maps.Pushpin(answer.results[0].location));
              }
            };
            searchManager.geocode(requestOptions);
          });
          document.getElementById('mapdirection').innerHTML = "Same Location";
        }
      }
      else{
        this.sharedService.notification.emit({
            severity: Severities[3],
            summary: CapitalizeFirstPipe.prototype.transform(Severities[3]),
            detail: this.translate.instant("INVALIDKEY")
        });
        return;
    }
});  

    
  }

  refreshBingMap() {
    var loc2 = new Microsoft.Maps.Location(this.TechStartPoint, this.TechEndtPoint);
    var pin2 = new Microsoft.Maps.Pushpin(loc2, { icon: '../assets/img/live-map/car.png' });
    var pathLine = [];
    let linepath = this.responseJobStatusPopupList.jobStatuPopuplatlanList;
    for (var i = 0; i < linepath.length; i++)
      pathLine[i] = new Microsoft.Maps.Location(linepath[i].lat, linepath[i].lng);
    var line = new Microsoft.Maps.Polyline(pathLine, { strokeColor: 'red' });
    // this.bing.setView({  zoom: 7 });
    if (pathLine.length > 0)
      this.bing.entities.push(line);

    this.bing.entities.remove(pin2);
    var lenth = this.responseJobStatusPopupList.jobStatuPopuplatlanList.length;
    var jobstatusobjectLenth = this.responseJobStatusPopupList.jobStatuPopuplatlanList.length;
    if (lenth <= jobstatusobjectLenth) {
      var path = [];
      var j = 0;
      for (var i = lenth - 1; i < jobstatusobjectLenth; i++) {
        path[j] = new Microsoft.Maps.Location(this.responseJobStatusPopupList.jobStatuPopuplatlanList[i].lat, this.responseJobStatusPopupList.jobStatuPopuplatlanList[i].lng)
        j = j + 1;
      }

      var path1 = [];
      for (var i = 0; i < jobstatusobjectLenth; i++)
        path1[i] = new Microsoft.Maps.Location(this.responseJobStatusPopupList.jobStatuPopuplatlanList[i].lat, this.responseJobStatusPopupList.jobStatuPopuplatlanList[i].lng)

      this.bing.entities.clear();
      var pin = new Microsoft.Maps.Pushpin(path[(path.length - 1)], { icon: '../assets/img/live-map/car.png' });
      this.bing.entities.push(pin);
      this.pathAnimation(path1, this.intervalCallback, true, 10000);
      var currentAnimation = new window.Bing.Maps.Animations.PathAnimation(path1, function (coord) {
        pin.setLocation(coord);
      }, true, this.MapRefreshTime);

      currentAnimation.play();
    }
  }

  intervalCallback(param1, param2) {

  }

  radToDeg(x) {
    return x * 180 / Math.PI;
  }

  calculateBearing(origin, dest) {
    var lat1 = this.degToRad(origin.latitude);
    var lon1 = origin.longitude;
    var lat2 = this.degToRad(dest.latitude);
    var lon2 = dest.longitude;
    var dLon = this.degToRad(lon2 - lon1);
    var y = Math.sin(dLon) * Math.cos(lat2);
    var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
    return (this.radToDeg(Math.atan2(y, x)) + 360) % 360;
  }

  degToRad(x) {
    return x * Math.PI / 180;
  }

  haversineDistance(origin, dest) {
    var EARTH_RADIUS_KM = 6378.1;
    var lat1 = this.degToRad(origin.latitude),
      lon1 = this.degToRad(origin.longitude),
      lat2 = this.degToRad(dest.latitude),
      lon2 = this.degToRad(dest.longitude);

    var dLat = lat2 - lat1,
      dLon = lon2 - lon1,
      cordLength = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(dLon / 2), 2),
      centralAngle = 2 * Math.atan2(Math.sqrt(cordLength), Math.sqrt(1 - cordLength));

    return EARTH_RADIUS_KM * centralAngle;
  }

  calculateCoord(origin, brng, arcLength) {
    var EARTH_RADIUS_KM = 6378.1;
    var lat1 = this.degToRad(origin.latitude),
      lon1 = this.degToRad(origin.longitude),
      centralAngle = arcLength / EARTH_RADIUS_KM;

    var lat2 = Math.asin(Math.sin(lat1) * Math.cos(centralAngle) + Math.cos(lat1) * Math.sin(centralAngle) * Math.cos(this.degToRad(brng)));
    var lon2 = lon1 + Math.atan2(Math.sin(this.degToRad(brng)) * Math.sin(centralAngle) * Math.cos(lat1), Math.cos(centralAngle) - Math.sin(lat1) * Math.sin(lat2));

    return new Microsoft.Maps.Location(this.radToDeg(lat2), this.radToDeg(lon2));
  }

  pathAnimation(path, intervalCallback, isGeodesic, duration) {
    var _delay = 30;
    var _totalDistance = 0,
      _intervalLocs = [path[0]],
      _intervalIdx = [0],
      _frameCount = Math.ceil(duration / _delay), idx;

    var progress, dlat, dlon;

    if (isGeodesic) {
      //Calcualte the total distance along the path in KM's.
      for (var i = 0; i < path.length - 1; i++) {
        _totalDistance += this.haversineDistance(path[i], path[i + 1]);
      }
    } else {
      //Calcualte the total distance along the path in degrees.
      for (var i = 0; i < path.length - 1; i++) {
        dlat = (path[i + 1].latitude - path[i].latitude);
        dlon = (path[i + 1].longitude - path[i].longitude);

        _totalDistance += Math.sqrt(dlat * dlat + dlon * dlon);
      }
    }



    //Pre-calculate midpoint locations for smoother rendering.
    for (var f = 0; f < _frameCount; f++) {
      progress = (f * _delay) / duration;

      var travel = progress * _totalDistance;
      var alpha;
      var dist = 0;
      var dx = travel;

      for (var i = 0; i < path.length - 1; i++) {

        if (isGeodesic) {
          dist += this.haversineDistance(path[i], path[i + 1]);
        } else {
          dlat = (path[i + 1].latitude - path[i].latitude);
          dlon = (path[i + 1].longitude - path[i].longitude);
          alpha = Math.atan2(dlat * Math.PI / 180, dlon * Math.PI / 180);
          dist += Math.sqrt(dlat * dlat + dlon * dlon);
        }

        if (dist >= travel) {
          idx = i;
          break;
        }

        dx = travel - dist;
      }

      if (dx != 0 && idx < path.length - 1) {
        if (isGeodesic) {
          var bearing = this.calculateBearing(path[idx], path[idx + 1]);
          _intervalLocs.push(this.calculateCoord(path[idx], bearing, dx));
        } else {
          dlat = dx * Math.sin(alpha);
          dlon = dx * Math.cos(alpha);

          _intervalLocs.push(new Microsoft.Maps.Location(path[idx].latitude + dlat, path[idx].longitude + dlon));
        }

        _intervalIdx.push(idx);
      }
    }

    //Ensure the last location is the last coordinate in the path.
    _intervalLocs.push(path[path.length - 1]);
    _intervalIdx.push(path.length - 1);

    return new window.Bing.Maps.Animations.BaseAnimation(
      function (progress, frameIdx) {
        if (intervalCallback) {
          intervalCallback(_intervalLocs[frameIdx], _intervalIdx[frameIdx], frameIdx);
        }
      }, duration);
  }

  createRotatedImagePushpin(location, url, rotationAngle, callback) {
    var img = new Image();
    img.onload = function () {
      var c = document.createElement('canvas');

      var rotationAngleRads = rotationAngle * Math.PI / 180;

      //Calculate rotated image size.
      c.width = Math.abs(Math.ceil(img.width * Math.cos(rotationAngleRads) + img.height * Math.sin(rotationAngleRads)));
      c.height = Math.abs(Math.ceil(img.width * Math.sin(rotationAngleRads) + img.height * Math.cos(rotationAngleRads)));

      var context = c.getContext('2d');

      //Move to the center of the canvas.
      context.translate(c.width / 2, c.height / 2);

      //Rotate the canvas to the specified angle in degrees.
      context.rotate(rotationAngleRads);

      //Draw the image, since the context is rotated, the image will be rotated also.
      context.drawImage(img, -img.width / 2, -img.height / 2);

      var pin = new Microsoft.Maps.Pushpin(location, {
        //Generate a base64 image URL from the canvas.
        icon: c.toDataURL(),
        anchor: new Microsoft.Maps.Point(c.width / 2, c.height / 2) //Anchor to center of image.
      });

      if (callback) {
        callback(pin);
      }
    };

    //Allow cross domain image editting.
    img.crossOrigin = 'anonymous';
    img.src = url;
  }

  close(success?: boolean) {
    if (this.isFull) {
      this.isFull = false;
    }
    else
      this.done.emit({ "key": "JobDetails", "value": success });
  }

  isFullScreen() {
    let doc: any = document;
    return !(!doc.fullscreenElement &&
      !doc.msFullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement);
  }

  isFull: boolean = false;
  toggleFullScreen() {
    this.isFull = true;
  }

  autoRefresh() {
    this.jobStatusPopupInputSearchEntity.CompanyId = super.globalInfo().CompanyId;
    this.jobStatusPopupInputSearchEntity.WoJobId = this.WoJobId;
    this.jobStatusPopupInputSearchEntity.TrackId = null;
    let trackRoute = this.responseJobStatusPopupList.jobStatuPopuplatlanList;
    let trackId = null;
    if (trackRoute && trackRoute.length > 0) {
      trackId = Math.max.apply(null, trackRoute.map(m => m.trackid));
    }
    this.jobStatusPopupInputSearchEntity.TrackId = trackId;
    this.woService.getJobStatusPopupList(this.jobStatusPopupInputSearchEntity, null, null, 0, 10)
      .subscribe(res => this.autoRefreshMap(res));
  }

  autoRefreshBingMap(res) {
    let oldData = this.responseJobStatusPopupList.jobStatuPopuplatlanList;
    let previousLastpath = null;
    if (oldData.length > 0) {
      previousLastpath = oldData[(oldData.length - 1)];

      this.bing.entities.clear();
      var pin = new Microsoft.Maps.Pushpin(previousLastpath, { icon: '../assets/img/live-map/car.png' });
      this.bing.entities.push(pin);

      var path1 = [];
      let newData = res.jobStatuPopuplatlanList;

      if (newData && newData.length > 0) {
        for (var i = 0; i < newData.length; i++) {
          path1[i] = new Microsoft.Maps.Location(newData[i].lat, newData[i].lng)
        }

        res.jobStatuPopuplatlanList.forEach(f => {
          this.responseJobStatusPopupList.jobStatuPopuplatlanList.push(f);
        });

        this.pathAnimation(path1, this.intervalCallback, true, 10000);
        var currentAnimation = new window.Bing.Maps.Animations.PathAnimation(path1, function (coord) {
          pin.setLocation(coord);
        }, true, this.MapRefreshTime);

        currentAnimation.play();
      }
    }
  }

  //#endregion
}